// ⇘⇘⇘⇘⇘⇘⇘   ⇓ ⇓ ⇓ ⇓ ⇓  ⇙⇙⇙⇙⇙⇙⇙⇙
// ⇒⇒⇒⇒⇒⇒ *R*E*A*C*T* ⇐⇐⇐⇐⇐⇐
// ⇗⇗⇗⇗⇗⇗⇗   ⇑ ⇑ ⇑ ⇑ ⇑  ⇖⇖⇖⇖⇖⇖⇖⇖

import React, { useEffect } from 'react';

// Basically bootstrap
import { Row, Col, Tabs, Tab } from 'react-bootstrap';

// Roba di redux
import { useSelector, useDispatch } from 'react-redux';

// Componente per navigare tra le paGGine
import { Link } from 'react-router-dom';

import _ from 'lodash';

// Funzioni scritte da me
import { bootstrapQualifiche } from './funzioni';

// Il mio input bellissimo per editare la cella
import Modifica from './components/modifica';
import UploadFile from './components/uploadFile';

// Type Mapping dal tipo restituito dall'api al tipo nativo dell'input
const typeMappings = {
  DATA: 'date',
  STRINGA: 'text',
  INTERO: 'number',
  DECIMALE: 'number',
};

// COMPONENTE PRINCIPALE A.K.A. LA PAggINA
const RatingSupp = ({ match }) => {
  // Prendo le variabili di stato dallo store redux (sarebbe un useState globale)
  const { caricamentoInCorso, idRating, qualificheSupp } = useSelector((state) => state.rating80);

  // Questo robo qui serve per chiamare le funzioni che modificano lo stato
  const dispatch = useDispatch();

  // Richiedo i dati supplementari del contratto al caricamento della pagina
  useEffect(bootstrapQualifiche, []);

  // Layout da mostrare se i dati supplementari vengono caricati con successo

  // Componente returnato di default
  return (
    <>
      <Row>
        <Col>
          {/* START SEZIONE TITOLO */}
          <section className="scroll-section mb-5" id="titolo">
            <h1>Rating</h1>
          </section>
          {/* END SEZIONE TITOLO */}

          <section className="scroll-section" id="dettagli-contratto">
            {
              /* Controllo se la pagina è in stato di caricamento */
              caricamentoInCorso ? (
                <p>Hang on...</p>
              ) : (
                /* Se non sta caricando, mostro il layout principale */

                <Tabs className="mb-3">
                  {
                    /* 
        Controllo he i dettagli supplementari sono preseni, e se lo sono 
        mostro latabella che li contiene
      */
                    qualificheSupp &&
                      qualificheSupp.map((item1, idx) => {
                        return (
                          <Tab eventKey={item1.nome} title={item1.nome} key={idx + 5}>
                            {Object.entries(_.groupBy(item1.campi, (e) => e.Paragrafo || 'No description')).map(([key, val], i) => {
                              return (
                                <Col key={key} className="my-5">
                                  <h2 className="d-block mb-3">{key}</h2>
                                  <Row className="g-3">
                                    {val.map((item, index) => {
                                      return item.Tipo.trim() === 'ALLEGATO' ? (
                                        <Col sm="12" md="6" lg="3" key={index * 50 + 1}>
                                          <UploadFile attach={item?.attach} descrizione={item.Descrizione} modificabile={!!item.Modifica} idDato={item.Dato} />
                                        </Col>
                                      ) : (
                                        <Col sm="12" md="6" lg="3" key={index}>
                                          <Modifica
                                            descrizione={item.Descrizione}
                                            tipo={typeMappings[item.Tipo.trim()]}
                                            valore={item.Valore}
                                            modificabile={item.Modifica}
                                            idDato={item.Dato}
                                            formatoData={item.Tipo.trim() === 'DATA'}
                                            possibleAnswers={item?.Response}
                                            attach={item?.Attach}
                                          />
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                  <hr />
                                </Col>
                              );
                            })}
                          </Tab>
                        );
                      })
                  }
                </Tabs>
              )
            }
          </section>
        </Col>
      </Row>
    </>
  );
};

export default RatingSupp;
